$( document ).ready(function() {

    let approachItems = $('.approach__items');
    approachItems.each(function (index, item) {

        $(item).hover(
            function () {
                removeClassItems()
                $(this).addClass('approach__items--active');
            },
            function () {
                // $(this).removeClass('approach__items--active');
            }
        );
    })

    function removeClassItems() {
        approachItems.each(function (index, item) {
            $(item).removeClass('approach__items--active');
        })
    }


});

